export default "__VITE_ASSET__BjOHf6S0__"